export default __webpack_public_path__ + "bf400661c005d8597892d9447fc241e9.svg";